export default "assets/images/icons/cart-f1c49d8a.svg";